import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Parkings (enrobés & asphalte)", href: "/services/parkings" },
  { label: "Dalles carrossables", href: "/services/dalles-carrossables" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function TerrassesPage() {
  return (
    <ServicePageLayout
      tag="Résidentiel & tertiaire"
      title="Terrasses"
      subtitle="Étanchéité de terrasses accessibles ou inaccessibles, avec finitions carrelées, gravillonnées ou végétalisées — pour particuliers et professionnels."
      heroImage="https://readdy.ai/api/search-image?query=beautiful%20modern%20rooftop%20terrace%20with%20pristine%20waterproofed%20surface%2C%20elegant%20stone%20tiles%2C%20city%20view%20panorama%2C%20blue%20sky%2C%20contemporary%20architecture%2C%20luxury%20residential%20building%2C%20professional%20real%20estate%20photography%2C%20stunning%20finish%2C%20wide%20angle&width=1440&height=900&seq=ksbtp-terr-hero-001&orientation=landscape"
      heroAlt="Étanchéité terrasse KS BTP"
      intro="Qu'il s'agisse d'une terrasse accessible carrelée, d'une terrasse gravillonnée inaccessible ou d'un espace végétalisé, KS BTP apporte une solution d'étanchéité durable et esthétique. Nous intervenons sur tous types de supports (béton, bois, métal) et proposons des systèmes adaptés à chaque usage : étanchéité liquide, membranes EPDM, complexes bitumineux. Chaque réalisation est pensée pour allier performance technique et rendu visuel soigné."
      techItems={[
        { icon: "ri-home-smile-line", label: "Terrasses accessibles" },
        { icon: "ri-leaf-line", label: "Terrasses végétalisées" },
        { icon: "ri-drop-line", label: "Étanchéité liquide" },
        { icon: "ri-shield-line", label: "Membranes EPDM" },
        { icon: "ri-grid-line", label: "Finition carrelée" },
        { icon: "ri-sun-line", label: "Terrasses inaccessibles" },
      ]}
      steps={[
        {
          number: "01",
          title: "Diagnostic",
          description: "Inspection de la terrasse existante, identification des infiltrations et évaluation du support.",
        },
        {
          number: "02",
          title: "Choix du système",
          description: "Sélection de la solution d'étanchéité adaptée à l'usage, au support et à la finition souhaitée.",
        },
        {
          number: "03",
          title: "Mise en œuvre",
          description: "Pose de l'étanchéité et des relevés, application de la finition (carrelage, gravillons, végétalisation).",
        },
        {
          number: "04",
          title: "Réception",
          description: "Test d'étanchéité, vérification des relevés et remise de la garantie décennale.",
        },
      ]}
      advantages={[
        "Solutions adaptées à tous types de terrasses : accessibles, inaccessibles, végétalisées",
        "Maîtrise des finitions : carrelage, gravillons, bois composite, végétalisation",
        "Traitement soigné des relevés, siphons et points singuliers",
        "Étanchéité liquide pour les formes complexes et les petites surfaces",
        "Intervention sur tous supports : béton, bois, métal",
        "Garantie décennale et esthétique soignée sur chaque chantier",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=elegant%20rooftop%20terrace%20with%20large%20format%20stone%20tiles%2C%20modern%20outdoor%20furniture%2C%20city%20skyline%20view%2C%20professional%20waterproofing%20underneath%2C%20luxury%20residential%20building%2C%20architectural%20photography&width=600&height=440&seq=ksbtp-terr-gal-001&orientation=landscape",
          alt: "Terrasse carrelée vue ville",
        },
        {
          src: "https://readdy.ai/api/search-image?query=green%20rooftop%20terrace%20with%20lush%20plants%20and%20grass%2C%20waterproofed%20base%2C%20modern%20urban%20building%2C%20professional%20landscaping%2C%20Paris%20architecture%2C%20beautiful%20garden%20on%20rooftop&width=600&height=440&seq=ksbtp-terr-gal-002&orientation=landscape",
          alt: "Terrasse végétalisée",
        },
        {
          src: "https://readdy.ai/api/search-image?query=professional%20worker%20applying%20liquid%20waterproofing%20membrane%20on%20terrace%20surface%20with%20roller%2C%20smooth%20grey%20coating%2C%20construction%20site%2C%20close%20up%20detail%2C%20professional%20photography&width=600&height=440&seq=ksbtp-terr-gal-003&orientation=landscape",
          alt: "Application étanchéité liquide terrasse",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
